import { REQUEST_TYPES } from '../requestTypes';
import { ENTITY_NAMES } from '../entityNames';
import { ENDPOINTS } from '../../../config/config';
import { EMPTY_OBJECT } from '../../../utils/constants';
import { type RequestHandlerFactory } from '../../types';

export const liveAgentsRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.LIVE_AGENTS]: params => {
        return {
            transformResponse: (res: any) => {
                const results = res?.[ENTITY_NAMES.LIVE_AGENTS]?.data ?? [];
                return {
                    entities: {
                        [ENTITY_NAMES.LIVE_AGENTS]: {
                            items: results,
                            itemsMeta: EMPTY_OBJECT
                        }
                    }
                };
            },
            descriptors: {
                [ENTITY_NAMES.LIVE_AGENTS]: {
                    defaultEndpoint: ENDPOINTS.EVENTS_URL,
                    method: 'get',
                    url: `/v1/users/team/${params?.filter?.[0] ?? 0}/status`,
                    data: params
                }
            }
        };
    }
};
